import moment from 'moment';
var isDateValidOrEmpty = function (format) {
    if (format === void 0) { format = 'DD.MM.YYYY'; }
    return function (value) {
        return moment(value, format, true).isValid() || value === '';
    };
};
export default isDateValidOrEmpty;
